export const DEFAULT_DASHBOARD_PATH = "/dashboard/operationadmin";

export const ROLE_DASHBOARD_MAP: Record<number, string> = {
  100: "/dashboard/superadmin",
  200: "/dashboard/admin",
  300: "/dashboard/customerservice",
  400: "/dashboard/operationadmin",
  500: "/dashboard/operationadmin",
  600: "/dashboard/operationadmin",
  700: "/dashboard/warehouse",
  800: "/dashboard/hr",
  900: "/dashboard/accounts",
  1000: "/transport-dashboard",
  1100: "/dashboard/payable",
  1200: "/accounts-receivable",
  1300: "/dashboard/maintenance",
  1500: "/dashboard/forwarding",
  1600: "/dashboard/driver-maintenance",
};

export function getDashboardPathByRole(roleId?: number | string | null): string {
  if (!roleId) {
    return DEFAULT_DASHBOARD_PATH;
  }

  const numericRoleId = Number(roleId);
  return ROLE_DASHBOARD_MAP[numericRoleId] ?? DEFAULT_DASHBOARD_PATH;
}

export function getDashboardPath(roleId?: number | string | null, permissionId?: number | string | null): string {
  const numericRoleId = Number(roleId);
  const numericPermissionId = Number(permissionId);
  if (numericRoleId === 1300 && numericPermissionId === 1) {
    return "/truck-maintenance-dashboard";
  }

  return getDashboardPathByRole(numericRoleId);
}
